/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface LocationDetailsOpenParams {
  experience_id: string;
}

/**
 * 発火タイミング: 体験詳細ページで「Location Details」モーダルを開いた時。
 *
 * Static マップ・最寄り駅の遅延ロード発火点であり、「開封数 ÷ 詳細PV」が Static の実課金
 * リクエスト数（コストの実測値）になる（Design Doc §計測イベント設計）。
 */
export const sendGAWabunkaLocationDetailsOpenEvent = (params: { experienceId: string }) => {
  sendWabunkaGAEvent('location_details_open', {
    experience_id: params.experienceId,
  });
};
